import React, { useRef, useCallback } from "react"
import { Field, LazyImage } from "ui"
import {useNode} from "../node"
import { useRect, useScroll, useScreen } from "lib"
//import { realPath } from "lib/util"

const colorStart = [230, 20, 25, 0]
const colorStop = [204, 50, 44, 1]
//const colorStop = [204, 72, 44, 1]
//const colorStop = [90, 15, 24]
// [hx, lx, sx]
/*const hmax = 209
const hmin = 90
const saturation = 20
const lightness = 60*/

const interpolate = (x, xMax) => colorStart.map((m, i) => m - (x * (m - colorStop[i])) / xMax)
const useImgScroll = (domRef, value) => {
    const screen = useScreen()
    const ref = useRef()
    const refIn = useRef()
    const index = useRef(0)
    const data = useRef({ w: 0, h: 0, top: 0 })
    const n = value.reduce((acc, v) => acc+(v.img?v.img.length:0), 0)
    const handleScroll = useCallback(
        scroll => {
            if (!refIn.current || scroll < data.current.top - screen.H) return
            const scrollVal = scroll - data.current.top +screen.H
            const delta = 0 //(data.current.screenH * 2) / 3
            const tr =
                scrollVal > delta
                  ? (-((scrollVal - delta) * data.current.w) / (data.current.h - delta) + screen.W*1.5)
                    : screen.W*1.5
            //console.log(scroll, scrollVal, tr)
            const ind = (scrollVal>screen.H?Math.ceil((scrollVal-1.5*screen.H)/(data.current.h/n)):0)
            if (ind!==index.current) {
                index.current = ind
                //console.log(ind)
                document.querySelectorAll(".dot").forEach(n => n.classList.remove("selected"))
                const dot = document.querySelector(`.dot-${index.current}`)
                //console.log(`.dot-${index.current}`, dot)
                if(dot) dot.classList.add("selected")
            }
            refIn.current.style.transform = `translate3d(${tr}px, 0, 0)`
            //const h = hmax - (scrollVal * (hmax - hmin)) / data.current.h
            const color = interpolate(scrollVal, data.current.h)
            domRef.current.style.background = `hsla(${color[0]}, ${color[1]}%, ${color[2]}%, ${
                color[3]
            })`
        },
        [domRef]
    )
    useRect(ref, () => {
        const r1 = ref.current.getBoundingClientRect()
        const items = refIn.current.querySelectorAll(".lazy")
        const n = items.length
        const r2 = items[0].getBoundingClientRect()
        data.current.w = r2.width * n
        data.current.h = r1.height
        data.current.screenH = r2.height
        data.current.top = r1.top + window.scrollY
        refIn.current.style.width = `${data.current.w}px`
        handleScroll(window.scrollY)
    })
    useScroll(handleScroll)
    return [ref, refIn, n]
}
/*
const Png2SVGMask = ({ id, img }) => (
    <svg viewBox={`0 0 ${img.w} ${img.h}`} className="lazy">
        <defs>
            <mask id={id}>
                <image width={img.w} height={img.h} xlinkHref={realPath(img.url, "pngmask")} />
            </mask>
        </defs>
        <image
            mask={`url(#${id})`}
            id="canTop"
            width={img.w}
            height={img.h}
            xlinkHref={realPath(img.url.replace(".png", ".jpg"), "pngmask")}
        />
    </svg>
)*/

const renderScroll = (n, value) => {
    let dots = []
    let i = 0
    if (!value) return dots
    for(let j=0;j<value.length;j++) {
        const v = value[j]
        if(v.img) {
        for (let k=0; k<v.img.length;k++) {
            const img = v.img[k]
            dots.push(
                <a key={i} href={`#dot-${i}`} className={`dot dot-${i}`}>
                  <LazyImage
                    src={img}
                    imageStyle="img100"
                    bg
                    preload
                    noth
                    />
                  <div className="dot-in"/>
                </a>)
            i++;
        }}
    }
    return dots
}
const renderLinks = n => {
    let dots = []

    for (let i=0; i<n; i++) {
        dots.push(<a key={i} href="#dot" name={`dot-${i}`}> </a>)
    }
    return dots
}

const EndowmentsPlayer = ({ domRef, info, value, children, className, ...props }) => {
    const [imgRef, imgRefIn, n] = useImgScroll(domRef, value)
    //console.log(n, value)
    const links = renderLinks(n)
    const dots = renderScroll(n, value)
    return (
        <div ref={domRef} player="" {...props}>
            <div ref={imgRef} className="img-container">
                <div className="img-container-in">
                    <div ref={imgRefIn} className="track">
                        <div className="track-in">
                            {value.map((v, i) =>
                                v.img
                                    ? v.img.map((img, j) => (
                                          <LazyImage
                                              key={`${i}:${j}`}
                                              src={img}
                                              imageStyle="img100"
                                              bg
                                              preload
                                              noth
                                          />
                                      ))
                                    : null
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="text-container">
                {value.map((v, i) => (
                    <section
                        key={i}
                        style={{
                            height: `${(v.img && v.img.length > 0 ? v.img.length : 1) * 100}vh`,
                        }}
                    >
                        <div className="item">
                            <Field info={info} field={`${i}.descr`} />
                        </div>
                        <div className="links">
                          {renderLinks(value, v, i)}
                          </div>
                    </section>
                ))}
        
        </div>
            
            <div className="links-container">
            <div className="links">
            {links}
        </div></div>
            <div className="scroll-container">
            <div className="scroll-inner"><div className="track">
            {dots}
            </div></div></div>
        </div>
    )
}
const EndowmentsCarousel = ({ domRef, info, value, children, ...props }) => {
    if (!value) return null
     return (
        <div ref={domRef} endw-carousel="" {...props}>
          {value.map((v,i) => 
                     <div key={i}>
                           <Field info={info} field={`${i}.descr`}/>
                               <Field info={info} field={`${i}.img`} carousel={true}/>
                     </div>
          )}
        </div>
    )
}
const Endowments = (props) => {
    const [state, setState] = React.useState(0)
    const screen = useScreen()
    const first = useNode("first")

    React.useLayoutEffect(() => {
        if (state===0 && screen.W<=1024 && first) setState(1)
    }, [screen, state, first])
    
    if (screen.W>0 && screen.W<=1024)
        return <EndowmentsCarousel {...props}/>
    return <EndowmentsPlayer {...props}/>
}
export default Endowments
